<b-container fluid="sm">
    <b-row align-v="center" class="pt-3">
        <b-col cols="12" md="6">
            <b-card title="Booking" type="secondary" shadow header-classes="bg-white">
                <b-card-text>
                    <div v-if="tripstatus === showTrip.search">
                        <b-form enctype="multipart/form-data">
                            <b-form-group label="Travel Date:" label-for="input-1">
                                <datepicker v-model="form.date" input-class="form-control" :format="customFormatter" :disabled-dates="disabledDates" placeholder="Select travel date"></datepicker>
                            </b-form-group>
                            <b-form-group label="Travel From:">
                                <b-form-select placeholder="Country" v-model="form.startingPoint"
                                    :options="destinations">
                                </b-form-select>
                            </b-form-group>
                            <b-form-group label="Travel To:">
                                <b-form-select placeholder="Country" v-model="form.destinationPoint"
                                    :options="destinationOptions">
                                </b-form-select>
                            </b-form-group>
                            <b-form-group label="Number of passengers:">
                                <b-form-select v-model='form.passengerCount' placeholder="Country"
                                    :options="passengersToBeBooked">
                                </b-form-select>
                            </b-form-group>
                            <div>
                                <b-button type="button" @click="getAvailability" variant="primary" class="my-4">
                                    Find Available trips
                                </b-button>
                            </div>
                        </b-form>
                    </div>
                    <div v-else-if="tripstatus === showTrip.available">
                        <div class="table-responsive">
                            <b-table striped hover :items="priceList.productList" :fields="fields">

                                <template #cell(totalAmount)="data">
                                    <span>R{{data.item.totalAmount}}</span>
                                </template>
                                <template #cell(extra1)="data">
                                    <span><button type="button" @click="Selected(data.item)">Select</button></span>
                                </template>
                            </b-table>
                        </div>
                        <div>
                            <b-button type="button" @click="resetToSearch" variant="primary" class="my-4">
                                Go back to search
                            </b-button>
                        </div>
                    </div>
                    <div v-else>
                        <div>
                            <b-alert show variant="info">
                                No bus is available on this day!
                            </b-alert>
                        </div>
                        <div>
                            <b-button type="button" @click="resetToSearch" variant="primary" class="my-4">
                                Go back to search
                            </b-button>
                        </div>
                    </div>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</b-container>